/* global gon */

import "app/helpers/compatibility";

import "../../components/desktop/setup";
import { Track } from "../../components/common/track";
import { logFunnelEvent, markLandingRendered, initInteractionTracking } from "../../app/helpers/classes/funnel_tracking";
import "air-datepicker/dist/js/datepicker.min.js";

import "../../components/desktop/searchfield/languages/datepicker.se";
import "air-datepicker/dist/css/datepicker.min.css";

import "app/setup";

import Searchfield from "components/desktop/searchfield";

//import Map from "@aobtravel/falco-webkit/src/components/molecules/map/map";
import { newComponent } from "@aobtravel/falco-webkit/src/support";

$(document).ready(() => {
  // This pack is shared between front/index (rebuilt) and step1 results
  // (see ApplicationHelper#webpack_component_files -- both map to
  // "desktop/step1"), and BOTH render through the same layout, which puts
  // `.tw-page` on <main> unconditionally. So `.tw-page` alone can't
  // distinguish them here -- use the controller-specific classes the
  // layout also adds (`page_front` / `page_step1`) instead. Both pages
  // embed the exact same common/searchfield/searchfield partial, and that
  // partial is now fully Stimulus-driven (search-submit, trip-type,
  // autocomplete, datepicker, passenger-picker controllers -- confirmed by
  // reading the partial tree, no data-controller wiring left needing
  // jQuery) -- so the legacy jQuery-UI Searchfield.load() must be skipped
  // on both, not just the front page. Verified live before this: without
  // this, switching Retur/Enkel/Multi-City on the *results* page's
  // searchfield fired both the old jQuery handler and the new Stimulus
  // trip-type controller for the same /load_form/:type fetch -- a real,
  // if not previously visibly broken, double-fetch race.
  const isRebuiltPage = document.querySelector("main.page_front, main.page_step1") !== null;

  markLandingRendered(gon.search_id);
  logFunnelEvent("landing_page_loaded", {
    search_id: gon.search_id,
    clicked_price: gon.clicked_price
  });
  if (gon.clicked_price) {
    logFunnelEvent("clicked_price", {
      search_id: gon.search_id,
      clicked_price: gon.clicked_price
    });
  }
  initInteractionTracking();

  if (!isRebuiltPage) {
    Searchfield.load();
  }

  // Results rendering (step_1_body) is now server-rendered +
  // step1_results_controller.js (see step_1.html.erb) for every brand --
  // no theme-specific override renders the old empty #step_1_body/Vue
  // mount point anymore (confirmed: no such override exists for any
  // gate). The Vue+Vuex+SearchChannel mount and debug_panel.vue (which
  // only ever showed SearchChannel debug info) are both gone; see git
  // history for the removed code if this ever needs resurrecting.

  setTimeout(
    function() {
      if(document.getElementById("trigger-search") !== null) {
        $(".main_btn_wide").click();
      } else {
      }
    }, 1
  );

  // See more in _hotel_info.html file
  const body = document.getElementsByTagName("body")[0];
  body.addEventListener("hotel-loaded", () => {
    const elem = document.querySelector("#map-canvas:not([attached])");
    if (typeof elem !== "undefined") {
      const lat = elem.getAttribute("data-lat");
      const lng = elem.getAttribute("data-lng");

      newComponent(elem, Map, {lat, lng});
      elem.setAttribute("attached", "");
    }
  }, false);

  $(".youth-tooltip").tooltipster({
    maxWidth: 400,
    contentAsHTML: true,
    trigger: "click"
  });

  // used at multiple places now, maybe we could have it in 1 later
  document.addEventListener("click", function(event){
    if (Array('checkbox', 'radio').includes(event.target.type)) {
      Track.log("Clicked on checkbox: " + event.target.name + " - ischecked: " + event.target.checked)
    }
  });

  // Session-timeout warning dialog is now Stimulus-driven (step1-timer
  // controller, wired directly in _session_timer_step1_dialog.html.erb) --
  // no JS needed here anymore, see that controller for the timer/reopen
  // logic this used to do via $.fancybox.open.
});
